import { validateImage } from '@/components/form/validate/img';
import { validateText } from '@/components/form/validate/text';
import { LIMIT_PIC } from '@/const/form';
import { BOT_CAI, formLitRender } from '@/const/lits';
import { ImageRatio } from '@/const/richMedia';
import { ICardForm, NarrationType, NarrationValue } from '@/interface';
import { isWoa } from '@/utils/getApiDomain';

import { fetchModelOptions, fetchTemplateOptions } from '../fetch/fetchBot-config';

const botRender = (key: string) => formLitRender(BOT_CAI, key);

export const botFormCard1: ICardForm = {
  key: 'botEasy',
  title: '基础信息',
  fieldsConfig: [
    {
      props: 'id',
      render: 'hidden',
      uiOptions: {
        disabled: true,
      },
    },
    {
      props: 'relatedId',
      render: 'hidden',
      uiOptions: {
        disabled: true,
      },
    },
    {
      props: '',
      label: '',
      render: 'bg',
      className: 'row-bot-bg',
    },
    {
      props: 'name',
      label: '角色名称',
      render: 'input',
      rules: [
        { required: true, message: '请填写角色名称' },
        { validator: e => validateText(e, '角色名称') },
      ],
      className: 'row-2-bot-left',
      uiOptions: {
        placeholder: '请输入角色名称',
        disabled: isWoa,
        maxlength: 10,
        showLimitNumber: true,
      },
    },
    {
      props: 'avatar',
      label: '头像',
      render: 'pic',
      className: 'row-bot-avatar',
      rules: [
        { required: true, message: '请上传头像' },
        { validator: e => validateImage(e, '头像') },
      ],
      uiOptions: {
        width: 140,
        height: 140,
        wrapStyle: {
          borderRadius: 83,
        },
        isImageCover: true,
        limit: { ratio: ImageRatio['1:1'] },
        disabled: isWoa,
        alertRender: `格式：1:1，文件大小 ≤ ${LIMIT_PIC.size}M`,
      },
    },
    // {
    //   props: 'addUserForeBackground',
    //   label: '人物立绘',
    //   render: 'pic',
    //   className: 'row-bot-foreBackground',
    //   rules: [
    //     // { required: true, message: '请上传人物立绘' },
    //     // { validator: e => validateImage(e, '人物立绘') },
    //   ],
    //   uiOptions: {
    //     width: 152,
    //     height: 270,
    //     isImageCover: true,
    //     disabled: isWoa,
    //     alertRender: `格式：竖版 9:16，文件大小 ≤ ${LIMIT_PIC.size}M，仅人物无背景`,
    //   },
    // },
    {
      props: 'chatBackground',
      label: '私聊背景',
      render: 'pic',
      className: 'row-bot-chatBackground',
      rules: [
      ],
      uiOptions: {
        width: 152,
        height: 270,
        isImageCover: true,
        disabled: isWoa,
        alertRender: `格式：竖版 9:16，文件大小 ≤ ${LIMIT_PIC.size}M，包括人物背景`,
      },
    },
    {
      props: 'intro',
      label: '角色简介',
      render: 'textarea',
      rules: [
      ],
      className: 'row-2-bot-right-intro',
      uiOptions: {
        autosize: { minRows: 6, maxRows: 6 },
        placeholder: '请输入角色简介',
        disabled: isWoa,
      },
    },
    {
      props: 'talking',
      label: '初始问候语',
      render: 'textarea',
      rules: [
      ],
      className: 'row-2-bot-right-talking',
      uiOptions: {
        autosize: { minRows: 6, maxRows: 6 },
        placeholder: '请输入初始问候语',
        disabled: isWoa,
      },
    },
    {
      props: 'voiceInfo',
      label: '语音包',
      render: botRender('VoicePlay'),
      className: 'row-2-box-left',
      labelSetting: {
        tipText: '为您的角色选择合适的语音包',
      },
      uiOptions: {
        disabled: isWoa,
      },
    },
  ],
};

export const botFormCard2: ICardForm = {
  key: 'botHard',
  title: '角色设定',
  fieldsConfig: [
    {
      props: 'narrationType',
      label: '情节续写',
      render: 'select',
      className: 'scene-narration',
      uiOptions: {
        options: Object.entries(NarrationValue).map(([key, value]) => ({
          label: value,
          value: parseInt(key, 10) as NarrationType,
        })),
      },
    },
    {
      props: 'visibility',
      label: '可见性',
      render: botRender('select'),
      className: 'row-2',
      labelSetting: {
        tipText: '谁可以与他聊天？',
      },
      uiOptions: {
        defaultValue: 3,
        options: [
          { value: 1, label: '公开：任何人都可以聊天' },
          { value: 2, label: '非公开：通过链接可见' },
          { value: 3, label: '私有：只有您可以聊天' },
        ],
      },
    },
    {
      props: 'phasesNew',
      label: '人物信息',
      render: botRender('CustomPhase2'),
      rules: [],
      uiOptions: {
        placeholder: '人物的身份、性格、关系等基本信息\n提到主角时，请用“用户”称呼',
      },
    },
    {
      props: 'userInstructionBase',
      label: '规则限制',
      render: botRender('textarea'),
      rules: [
      ],
      uiOptions: {
        autosize: { minRows: 5, maxRows: 5 },
        disabled: isWoa,
        placeholder: '对人物行为模式的要求\n提到主角时，请用“用户”称呼',
      },
    },
    {
      props: 'definitions',
      label: '与用户对话示例',
      render: 'customArrayQA',
      rules: [
      ],
      uiOptions: {
        disabled: isWoa,
        buttonSize: 'small',
      },
    },
    {
      props: '',
      render: 'formTitle',
      uiOptions: {
        border: true,
        title: '模板设置',
      },
    },
    {
      props: 'modelId',
      label: '模型',
      render: botRender('debounceSelect'),
      className: 'row-2-left',
      labelSetting: {
        tipText: '为您的角色选择合适的模型数据',
      },
      uiOptions: {
        openUpdateOptions: true,
        hasDefault: true,
        fetchOptions: fetchModelOptions,
      },
    },
    {
      props: 'templateId',
      label: '模板',
      render: botRender('debounceSelect'),
      className: 'row-2',
      labelSetting: {
        tipText: '为您的角色选择合适的模板',
      },
      uiOptions: {
        hasDefault: true,
        openUpdateOptions: true,
        placeholder: '默认',
        clearable: true,
        fetchOptions: fetchTemplateOptions,
      },
    },
    {
      props: '',
      render: 'formTitle',
      uiOptions: {
        border: true,
        title: '详细特征设定',
      },
    },
    {
      props: 'initScore',
      render: 'inputNumber',
      label: '初始数值',
      uiOptions: {
        min: 0,
        max: 100,
      },
    },
    {
      props: 'scoreRules',
      render: 'CustomScoreRules',
      label: '分数规则',
      uiOptions: {
      },
      hasCollapse: true,
    },
    {
      props: 'phaseSelectors',
      render: 'CustomPhaseSelector',
      label: '人设选择器',
      uiOptions: {
      },
      hasCollapse: true,
    },
    {
      props: 'userInstructionNew',
      label: '指令要求',
      render: 'customArrayQA',
      rules: [
      ],
      uiOptions: {
        buttonSize: 'small',
      },
    },
    {
      props: '',
      render: 'formTitle',
      uiOptions: {
        border: true,
        title: '功能逻辑',
      },
    },
    {
      props: 'ignoreMemory',
      label: '使用记忆',
      render: botRender('numSwitch'),
      labelSetting: {
        tipText: '与角色对话聊天是否使用之前记忆',
      },
      uiOptions: {
        size: 'large',
        label: ['使用', '关闭'],
        defaultValue: 0,
      },
    },
    {
      props: 'reqBottomReplies',
      label: '请求兜底回复',
      render: 'inputArray',
      rules: [
      ],
      uiOptions: {
        drag: true,
        buttonSize: 'small',
      },
    },
    {
      props: 'rspBottomReplies',
      label: '响应兜底回复',
      render: 'inputArray',
      rules: [
      ],
      uiOptions: {
        drag: true,
        buttonSize: 'small',
      },
    },
    {
      props: 'replaceMsgTextConf',
      label: '替换规则',
      render: botRender('customArrayReplaceMsg'),
      labelSetting: {
        tipText: '角色回复的消息中，命中需要替换的字符串时，替换为配置的内容',
      },
      rules: [
      ],
      uiOptions: {
        buttonSize: 'small',
      },
    },
    {
      props: 'knowledgeIds',
      label: '知识库',
      render: botRender('customUploadSelect'),
      labelSetting: {
        tipText: '为您的角色选择合适的知识库',
      },
      uiOptions: {
        modal: {
          text: '对话效果',
          modalConfig: {
            width: 547,
            height: 219,
          },
          modalTitle: {
            title: '上传知识库',
          },
          fieldsConfig: [
            {
              props: 'knowledgeName',
              label: '名称',
              render: 'input',
              className: 'modal-form-item',
              rules: [{ require: true }],
            },
            {
              props: 'knowledgeFile',
              label: '知识库文件',
              render: 'file',
              className: 'modal-form-item',
              rules: [{ require: true }],
              uiOptions: {
                limit: {
                  fileType: ['.txt'],
                },
              },
            },
          ],
        },
      },
    },
  ],
};

export const botFormCard3: ICardForm = {
  key: 'botNormal',
  title: '角色设定',
  fieldsConfig: [
    {
      props: 'phasesNew',
      label: '人物信息',
      render: botRender('CustomPhase1'),
      rules: [
      ],
      uiOptions: {
        autosize: { minRows: 5, maxRows: 5 },
        disabled: isWoa,
        placeholder: '人物的身份、性格、关系等基本信息\n提到主角时，请用“用户”称呼',
      },
    },
    {
      props: 'userInstructionBase',
      label: '规则限制',
      render: botRender('textarea'),
      rules: [
      ],
      uiOptions: {
        autosize: { minRows: 5, maxRows: 5 },
        disabled: isWoa,
        placeholder: '对人物行为模式的要求\n提到主角时，请用“用户”称呼',
      },
    },
    {
      props: 'definitions',
      label: '与用户对话示例',
      render: 'customArrayQA',
      rules: [
      ],
      uiOptions: {
        buttonSize: 'small',
        disabled: isWoa,
      },
    },
  ],
};

